module.exports = __webpack_public_path__ + "img/cnDetailBg.35cd6d4c.png";